<template>
  <RewardAdPlayer />
  <a-modal v-model:open="offerOpen" title="看广告，领取 Credits" :footer="null" width="420px">
    <div v-if="daily" class="daily-offer">
      <i class="ri-gift-2-line" aria-hidden="true" />
      <div>
        <strong>{{ daily.title }}</strong>
        <p>{{ daily.description }}</p>
      </div>
      <a-button type="primary" block @click="start"
        >观看 {{ daily.durationSeconds }} 秒，领取 {{ daily.rewardCredits }} Credits</a-button
      >
      <span>完全自愿，不影响任何工作台功能。</span>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { message } from 'ant-design-vue';
import RewardAdPlayer from './RewardAdPlayer.vue';
import { useAdvertisingStore } from '@/stores/advertising.store';
import { useAuthStore } from '@/stores/auth.store';
const route = useRoute();
const auth = useAuthStore();
const store = useAdvertisingStore();
const offerOpen = ref(false);
let offerTimer: ReturnType<typeof setTimeout> | null = null;
const daily = computed(() => store.overview?.dailyOffer ?? null);
function key(): string {
  return `advertising-daily-offer:${new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Shanghai' })}`;
}
async function load(): Promise<void> {
  if (!auth.isAuthenticated) return;
  try {
    await store.refresh();
  } catch {
    /* 广告服务不可用不影响主应用 */
  }
}
function scheduleOffer(): void {
  if (offerTimer) clearTimeout(offerTimer);
  if (
    !route.path.startsWith('/w/') ||
    !daily.value ||
    store.overview?.automaticSuppressed ||
    sessionStorage.getItem(key())
  )
    return;
  offerTimer = setTimeout(() => {
    offerOpen.value = true;
    sessionStorage.setItem(key(), '1');
  }, 5000);
}
async function start(): Promise<void> {
  if (!daily.value) return;
  try {
    await store.start(daily.value, 'daily_reward');
    offerOpen.value = false;
  } catch (error) {
    message.warning((error as { message?: string }).message ?? '当前广告不可用');
  }
}
watch(
  () => auth.isAuthenticated,
  (active) => {
    if (active) void load();
  },
  { immediate: true },
);
watch([() => route.path, daily, () => store.overview?.automaticSuppressed], scheduleOffer);
onMounted(() => {
  if (auth.isAuthenticated) void load();
});
onBeforeUnmount(() => {
  if (offerTimer) clearTimeout(offerTimer);
});
</script>

<style scoped>
.daily-offer {
  display: grid;
  gap: 14px;
  text-align: center;
}
.daily-offer > i {
  margin: 4px auto 0;
  color: var(--aw-primary);
  font-size: 42px;
}
.daily-offer strong {
  color: var(--aw-text);
  font-size: 18px;
}
.daily-offer p {
  margin: 8px 0 0;
  color: var(--aw-text-secondary);
}
.daily-offer > span {
  color: var(--aw-text-tertiary);
  font-size: 12px;
}
</style>
